/**
 * Header Autocomplete
 *
 * Initializes Algolia autocomplete in the Blade header for non-Vue pages.
 * This is a standalone implementation that includes query suggestions from Typesense.
 */

import { createAutocompleteInstance } from "../shared/autocomplete-factory";
import type { SearchConfig } from "../services/SearchClientFactory";

let autocompleteInstance: ReturnType<typeof createAutocompleteInstance> | null =
    null;
let autocompleteInstanceMobile: ReturnType<
    typeof createAutocompleteInstance
> | null = null;

/**
 * Initialize header autocomplete instances
 */
export function initHeaderAutocomplete(): void {
    const searchConfig: SearchConfig | null =
        (window as any).__SEARCH_CONFIG__ || null;

    if (
        document.getElementById("header-autocomplete") &&
        !autocompleteInstance
    ) {
        autocompleteInstance = createAutocompleteInstance({
            containerId: "header-autocomplete",
            searchConfig,
        });
    }

    if (
        document.getElementById("header-autocomplete-mobile") &&
        !autocompleteInstanceMobile
    ) {
        autocompleteInstanceMobile = createAutocompleteInstance({
            containerId: "header-autocomplete-mobile",
            searchConfig,
        });
    }
}

/**
 * Cleanup autocomplete instances
 */
export function cleanupHeaderAutocomplete(): void {
    if (autocompleteInstance) {
        autocompleteInstance.destroy();
        autocompleteInstance = null;
    }
    if (autocompleteInstanceMobile) {
        autocompleteInstanceMobile.destroy();
        autocompleteInstanceMobile = null;
    }
}

// Auto-initialize on page load (Inertia / app.ts entry)
if (typeof document !== "undefined") {
    const init = () => {
        initHeaderAutocomplete();
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    document.addEventListener("inertia:finish", () => {
        requestAnimationFrame(() => {
            initHeaderAutocomplete();
        });
    });
}
